/** Match Python json.dumps on JSON received from the browser (ensure_ascii=False, sort_keys=True). */
export function pythonCanonicalJson(value: unknown): string {
  // Normalize undefined and non-JSON properties exactly as the HTTP body does first.
  const normalized: unknown = JSON.parse(JSON.stringify(value));
  const encode = (item: unknown): string => {
    if (item === null || typeof item === 'boolean' || typeof item === 'string') return JSON.stringify(item);
    if (typeof item === 'number') {
      const browser = JSON.stringify(item);
      // Python parses non-exponential integral JSON as an int, preserving the wire spelling.
      if (!browser.includes('.') && !browser.includes('e')) return browser;
      const number = Math.abs(item);
      let result = number !== 0 && number < 0.0001 ? item.toExponential() : browser;
      result = result.replace(/e([+-])(\d)$/, 'e$10$2');
      return result;
    }
    if (Array.isArray(item)) return '[' + item.map(encode).join(',') + ']';
    if (typeof item === 'object') return '{' + Object.keys(item as object).sort().map(key =>
      JSON.stringify(key) + ':' + encode((item as Record<string, unknown>)[key])).join(',') + '}';
    throw new Error('Invalid snapshot');
  };
  return encode(normalized);
}

export async function canvasHash(canvas: unknown): Promise<string> {
  const bytes = new TextEncoder().encode(pythonCanonicalJson(canvas));
  const hash = await crypto.subtle.digest('SHA-256', bytes);
  return [...new Uint8Array(hash)].map(value => value.toString(16).padStart(2, '0')).join('');
}
